export var DEFAULT_HEARTBEAT_ENDPOINT = '/gateway/api/session/heartbeat';
export var DEFAULT_IDLE_TIME = 60000;
export var INTERVAL_TIME = 10000;